<div class="scroll-container" tabindex="0">
    <div class="content-background my-3">
        <div class="modal-header p-3">
            <h3 class="modal-title" id="modal-title" translate="FDA_2579_FORM_TITLE"></h3>
        </div>
    </div>
    <div class="row p-3">
        <form class="col" [formGroup]="fda2579FormGroup">
            <pace-core-accordion
                [accordionOpened]="model.accordionOpenedStatus.equipmentInfo"
                (openChanged)="model.accordionOpenedStatus.equipmentInfo = true"
                [accordionInvalid]="fda2579FormEquipmentChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="FDA_2579_FORM_EQUIPMENT_LOCATION_SECTION"></span>
                </div>
                <div sectionBody>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="LocationName"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_ASSEMBLER_COMPANY_NAME_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="LocationName"
                                [(model)]="model.notificationAddress.name1"
                                [parentForm]="fda2579FormEquipmentChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="LocationStreet"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_STREET_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="LocationStreet"
                                [(model)]="model.notificationAddress.street"
                                [parentForm]="fda2579FormEquipmentChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerCity"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_CITY_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="LocationCity"
                                [(model)]="model.notificationAddress.city"
                                [parentForm]="fda2579FormEquipmentChildren"
                                (valueChange)="onCityChange()"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    @if (model.notificationAddress.statesOfUSA) {
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="AssemblerState"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="FDA_2579_FORM_STATE_LABEL"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-dropdown
                                    id="LocationState"
                                    [(model)]="model.notificationAddress.statesOfUSA"
                                    [parentForm]="fda2579FormEquipmentChildren"
                                ></pace-core-dropdown>
                            </div>
                        </div>
                    }
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerZipCode"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_ZIP_CODE_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="LocationZipCode"
                                [(model)]="model.notificationAddress.postalCode"
                                [parentForm]="fda2579FormEquipmentChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="LocationPhoneNumber"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_PHONE_NUMBER_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="LocationPhoneNumber"
                                [(model)]="model.notificationAddress.phone"
                                [parentForm]="fda2579FormEquipmentChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                </div>
                <div closeButton>
                    <span translate="FDA_2579_FORM_CLOSE_SECTION"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                [accordionOpened]="model.accordionOpenedStatus.assemblerInfo"
                (openChanged)="model.accordionOpenedStatus.assemblerInfo = true"
                [accordionInvalid]="fda2579FormAssemblerInfoChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="FDA_2579_FORM_ASSEMBLER_INFORMATION_SECTION"></span>
                </div>
                <div sectionBody>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerCompanyName"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_ASSEMBLER_COMPANY_NAME_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="AssemblerCompanyName"
                                [(model)]="model.assemblerCompanyName"
                                [parentForm]="fda2579FormAssemblerInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerStreet"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_STREET_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="AssemblerStreet"
                                [(model)]="model.assemblerStreet"
                                [parentForm]="fda2579FormAssemblerInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerCity"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_CITY_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="AssemblerCity"
                                [(model)]="model.assemblerCity"
                                [parentForm]="fda2579FormAssemblerInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerState"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_STATE_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="AssemblerState"
                                [(model)]="model.assemblerState"
                                [parentForm]="fda2579FormAssemblerInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="AssemblerZipCode"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_ZIP_CODE_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="AssemblerZipCode"
                                [(model)]="model.assemblerZipCode"
                                [parentForm]="fda2579FormAssemblerInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="PhoneNumber"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_PHONE_NUMBER_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="PhoneNumber"
                                [(model)]="model.assemblerPhoneNumber"
                                [parentForm]="fda2579FormAssemblerInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                </div>
                <div closeButton>
                    <span translate="FDA_2579_FORM_CLOSE_SECTION"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                [accordionOpened]="model.accordionOpenedStatus.generalInfo"
                (openChanged)="model.accordionOpenedStatus.generalInfo = true"
                [accordionInvalid]="fda2579FormGeneralInfoChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="FDA_2579_FORM_GENERAL_INFORMATION_SECTION"></span>
                </div>
                <div sectionBody>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            class="col-12 col-form-label text-start pe-3"
                            translate="FDA_2579_FORM_GENERAL_INFORMATION_ASSEMBLE_REPORT_LABEL"
                        ></label>
                        @for (
                            certifiedItem of model.certifiedComponentCheckboxList;
                            track certifiedItem;
                            let i = $index
                        ) {
                            <div class="col-6 col-sm-8 col-lg-4 mt-2">
                                <pace-core-checkbox-input
                                    [(model)]="model.certifiedComponentCheckboxList[i]"
                                    [parentForm]="fda2579FormGeneralInfoChildren"
                                    [checkBoxID]="'certifiedItem' + i"
                                ></pace-core-checkbox-input>
                            </div>
                        }
                    </div>
                    <hr class="separator" />
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            class="col-12 col-form-label text-start pe-3"
                            translate="FDA_2579_FORM_GENERAL_INFORMATION_INTENDED_USES_LABEL"
                        ></label>
                        @for (intendedUser of model.intendedUsesCheckboxList; track intendedUser; let i = $index) {
                            <div class="col-6 col-sm-8 col-lg-4 mt-2">
                                <pace-core-checkbox-input
                                    [(model)]="model.intendedUsesCheckboxList[i]"
                                    [parentForm]="fda2579FormGeneralInfoChildren"
                                    [checkBoxID]="'intendedUser' + i"
                                ></pace-core-checkbox-input>
                            </div>
                        }
                    </div>
                    <hr class="separator" />
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            class="col-12 col-sm-8 col-lg-3 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_GENERAL_INFORMATION_XRAY_SYSTEM_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-dropdown
                                [(model)]="model.xRaySystemDropdown"
                                [parentForm]="fda2579FormGeneralInfoChildren"
                            ></pace-core-dropdown>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="masterControlRoomNumber"
                            class="col-12 col-sm-8 col-lg-3 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_GENERAL_INFORMATION_MASTER_CONTROL_ROOM_NO_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="masterControlRoomNumber"
                                [(model)]="model.masterControlRoomNumber"
                                [parentForm]="fda2579FormGeneralInfoChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="DateOfAssembly"
                            class="col-12 col-sm-8 col-lg-3 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_GENERAL_INFORMATION_DATE_OF_ASSEMBLY_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-date-input
                                id="DateOfAssembly"
                                [(model)]="model.dateOfAssembly"
                                [parentForm]="fda2579FormGeneralInfoChildren"
                            ></pace-core-date-input>
                        </div>
                    </div>
                </div>
                <div closeButton>
                    <span translate="FDA_2579_FORM_CLOSE_SECTION"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                [accordionOpened]="model.accordionOpenedStatus.componentInfo"
                (openChanged)="model.accordionOpenedStatus.componentInfo = true"
                [accordionInvalid]="fda2579FormComponentInfoChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="FDA_2579_FORM_COMPONENT_INFORMATION_SECTION"></span>
                </div>
                <div sectionBody>
                    <ng-container>
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="masterControlDropdown"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="FDA_2579_FORM_MASTER_CONTROL_LABEL"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-dropdown
                                    id="masterControlDropdown"
                                    [(model)]="model.masterControl"
                                    [parentForm]="fda2579FormComponentInfoChildren"
                                ></pace-core-dropdown>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="controlManufacturer"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="FDA_2579_FORM_CONTROL_MANUFACTURER"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="controlManufacturer"
                                    [(model)]="model.controlManufacturer"
                                    [parentForm]="fda2579FormComponentInfoChildren"
                                ></pace-core-text-input>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="controlModelNumber"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="FDA_2579_FORM_CONTROL_MODEL_NUMBER"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="controlModelNumber"
                                    [(model)]="model.controlModelNumber"
                                    [parentForm]="fda2579FormComponentInfoChildren"
                                ></pace-core-text-input>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="controlSerialNumber"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="FDA_2579_FORM_CONTROL_SERIAL_NUMBER"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-text-input
                                    id="controlSerialNumber"
                                    [(model)]="model.controlSerialNumber"
                                    [parentForm]="fda2579FormComponentInfoChildren"
                                ></pace-core-text-input>
                            </div>
                        </div>
                        <div class="d-flex flex-wrap mb-3 align-items-center">
                            <label
                                for="controlManufacturedDate"
                                class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                translate="FDA_2579_FORM_CONTROL_DATE_MANUFACTURED"
                            ></label>
                            <div class="col-12 col-sm-8 col-lg-4">
                                <pace-core-date-input
                                    id="controlManufacturedDate"
                                    [(model)]="model.manufacturedDate"
                                    [parentForm]="fda2579FormComponentInfoChildren"
                                ></pace-core-date-input>
                            </div>
                        </div>
                        @if (model.showControlSystemName) {
                            <div class="d-flex flex-wrap mb-3 align-items-center">
                                <label
                                    for="controlSystemName"
                                    class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                                    translate="FDA_2579_FORM_SYSTEM_MODEL_NAME"
                                ></label>
                                <div class="col-12 col-sm-8 col-lg-4">
                                    <pace-core-text-input
                                        id="controlSystemName"
                                        [(model)]="model.systemModelName"
                                        [parentForm]="fda2579FormComponentInfoChildren"
                                    ></pace-core-text-input>
                                </div>
                            </div>
                        }
                    </ng-container>
                    <hr class="separator" />
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <div class="row col-12 mb-3">
                            <label class="col-4 col-form-label" translate="FDA_2579_FORM_MANUFACTURER_LABEL"></label>
                            <label class="col-4 col-form-label" translate="FDA_2579_FORM_MODEL_NUMBER_LABEL"></label>
                            <label
                                class="col-3 col-form-label"
                                translate="FDA_2579_FORM_MANUFACTURED_DATE_LABEL"
                            ></label>
                            <label class="col-1"></label>
                        </div>
                        @for (component of model.componentList.value; track component; let i = $index) {
                            <div class="row col-12 mb-3">
                                <div class="col-12 col-sm-8 col-lg-4">
                                    <pace-core-text-input
                                        id="manufacturer"
                                        [(model)]="component.manufacturer"
                                        [parentForm]="fda2579FormComponentInfoChildren"
                                    ></pace-core-text-input>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-4">
                                    <pace-core-text-input
                                        id="modelNUmber"
                                        [(model)]="component.modelNumber"
                                        [parentForm]="fda2579FormComponentInfoChildren"
                                        (valueChange)="model.updateManufacturedDateOptions(i)"
                                    ></pace-core-text-input>
                                </div>
                                <div class="col-12 col-sm-8 col-lg-3">
                                    <pace-core-date-input
                                        id="manufacturedDate"
                                        [(model)]="component.manufacturedDate"
                                        [parentForm]="fda2579FormComponentInfoChildren"
                                    ></pace-core-date-input>
                                </div>
                            </div>
                        }
                    </div>
                    <hr class="separator" />
                    <h6 translate="FDA_2579_FORM_COMPONENT_OTHER_CERTIFIED_HEADING_LABEL_1"></h6>
                    <a translate="FDA_2579_FORM_COMPONENT_OTHER_CERTIFIED_HEADING_LABEL_2"></a>
                    <div class="row">
                        @for (
                            certifiedItem of model.otherCertifiedComponentDropdownList;
                            track certifiedItem;
                            let i = $index
                        ) {
                            <div class="col-8 col-sm-8 col-lg-4 mt-2 d-flex flex-wrap align-items-center">
                                <label class="col-lg-7 col-md-3 col-form-label"> {{ certifiedItem.label }} </label>
                                <pace-core-dropdown
                                    class="col-4 p-0"
                                    [(model)]="model.otherCertifiedComponentDropdownList[i].dropdownModel"
                                    [parentForm]="fda2579FormGeneralInfoChildren"
                                ></pace-core-dropdown>
                                @if (certifiedItem.exceedsMaxValue) {
                                    <div class="col-11 invalid-entries">
                                        Select upto {{ certifiedItem.maxValue }} value
                                    </div>
                                }
                            </div>
                        }
                    </div>
                </div>
                <div closeButton>
                    <span translate="FDA_2579_FORM_CLOSE_SECTION"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                [accordionOpened]="model.accordionOpenedStatus.comments"
                (openChanged)="model.accordionOpenedStatus.comments = true"
                [accordionInvalid]="fda2579FormCommentsChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="FDA_2579_FORM_COMMENTS_SECTION"></span>
                </div>
                <div sectionBody>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="comments"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_COMMENTS_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-8">
                            <pace-core-text-input
                                id="comments"
                                [(model)]="model.comments"
                                [parentForm]="fda2579FormCommentsChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                </div>
                <div closeButton>
                    <span translate="FDA_2579_FORM_CLOSE_SECTION"></span>
                </div>
            </pace-core-accordion>
            <pace-core-accordion
                [accordionOpened]="model.accordionOpenedStatus.assemblerCertification"
                (openChanged)="model.accordionOpenedStatus.assemblerCertification = true"
                [accordionInvalid]="fda2579FormCertificationChildren.invalid"
            >
                <div sectionHeader>
                    <span translate="FDA_2579_FORM_ASSEMBLER_CERTIFICATION_SECTION"></span>
                </div>
                <div sectionBody>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <span class="block leading-relaxed text-justify my-3 p-2"
                            >I affirm that all certified components assembled or installed by me, for which this report
                            is being made, were adjusted and tested by me according to the instructions provided by the
                            manufacture(s), were of the type required by the manufacturer(s), were of the type required
                            by the diagnostic x-ray performance standard (21 CFR Part 1020), were not modified to
                            adversely affect performance, and were installed in accordance with provisions of 21 CFR
                            Part 1020. I also affirm that all instruction manuals and other information required by 21
                            CFR Part 1020 for this assembly have been furnished to the purchaser and, within 15 days
                            following completion of the assembly, a copy of this form will be submitted to the purchaser
                            and, where applicable, to the State agency responsible for radiation protection.
                        </span>
                        <label
                            for="signatureDate"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_SIGNATURE_DATE_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-date-input
                                id="signatureDate"
                                [(model)]="model.signatureDate"
                                [parentForm]="fda2579FormCertificationChildren"
                            ></pace-core-date-input>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap mb-3 align-items-center">
                        <label
                            for="serviceEngineerEmail"
                            class="col-12 col-sm-8 col-lg-2 col-form-label text-lg-end text-start pe-3"
                            translate="FDA_2579_FORM_SERVICE_ENGINEER_EMAIL_LABEL"
                        ></label>
                        <div class="col-12 col-sm-8 col-lg-4">
                            <pace-core-text-input
                                id="serviceEngineerEmail"
                                [(model)]="model.serviceEngineerEmail"
                                [parentForm]="fda2579FormCertificationChildren"
                            ></pace-core-text-input>
                        </div>
                    </div>
                </div>
                <div closeButton>
                    <span translate="FDA_2579_FORM_CLOSE_SECTION"></span>
                </div>
            </pace-core-accordion>
        </form>
    </div>
    <nav class="navbar bg-light fixed-bottom">
        <ul class="navbar-nav">
            <li class="nav-item ps-2">
                @if (!isFDA2579Saving) {
                    <button
                        class="btn btn-lg btn-success"
                        type="button"
                        (click)="saveAndCloseFdaForm()"
                        translate="FDA_2579_FORM_SAVE_AND_CLOSE_LABEL"
                    ></button>
                }
            </li>
        </ul>
        @if (isFDA2579Saving) {
            <progressbar [value]="100" type="default">Saving...</progressbar>
        }
    </nav>
</div>
